import { render, staticRenderFns } from "./Top20Credit.vue?vue&type=template&id=24d6e51e&"
import script from "./Top20Credit.vue?vue&type=script&lang=js&"
export * from "./Top20Credit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports